require('../../modules/es6.number.parse-float');
module.exports = parseFloat;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/number/parse-float.js
// module id = 412
// module chunks = 1